"use strict";

exports.__esModule = true;
exports.formatToPlantTime = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _libCalendar = require("@vimana/lib-calendar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formatToPlantTime = exports.formatToPlantTime = function formatToPlantTime(_ref) {
  var data = _ref.data,
    timezone = _ref.timezone,
    _ref$binName = _ref.binName,
    binName = _ref$binName === void 0 ? "key" : _ref$binName;
  return data.map(function (doc) {
    var _Object$assign;
    return Object.assign({}, doc, (_Object$assign = {}, _Object$assign[binName] = (0, _momentTimezone["default"])(doc[binName]).tz(timezone.name).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"), _Object$assign));
  });
};